import { faEye, faFileInvoice, faFilePdf, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loader from 'Common/Loader';
import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Modal } from 'react-bootstrap';
import CustomStore from 'devextreme/data/custom_store';
import { HttpStatus } from 'modules/core';
import { toast } from 'react-toastify';
import notistack from 'modules/core/notistack';
import ShowCustomerOrderListModal from './ShowCustomerOrderModal';
import { GetEstimatePyamentInvoice } from '../service';
import { useNavigate } from 'react-router-dom';

interface ActionModalProp {
    receiptNo: string;
    selectedId: number;
    customerId: any;
    reloadDataSource(): void;
}

const ActionModal = ({
    receiptNo,
    selectedId,
    customerId,
    reloadDataSource,
    autoOpen,
}: ActionModalProp & { autoOpen?: boolean }) => {

    const [loading, setLoading] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showVoucherModal, setShowVoucherModal] = useState(false);
    const [pdfData, setPdfData] = useState<string | null>(null);

    const handelrecipet = async () => {
        setLoading(true);
        try {
            const response = await GetEstimatePyamentInvoice(receiptNo);
            setPdfData(response);
            setShowVoucherModal(true);

        } catch (error) {
            console.error("Failed to load PDF", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (autoOpen) {
            handelrecipet();
        }
    }, [autoOpen]);

    const handleClose = () => {
        setShowViewModal(false)
    }

    const navigate = useNavigate();


    const encodeValue = (value: any) => btoa(encodeURIComponent(value));

    // handle Navigate custome order to sales entery 
    const handleCustomOrderToSalesEntery = () => {
        const coidHash = encodeValue(String(selectedId));
        const cidHash = encodeValue(String(customerId));
        navigate(`/new-transaction-entry/${coidHash}/${cidHash}`);
    }
    return (
        <>
            {loading && <Loader />}
            <button className='btn btn-sm action-btn' title='View Receipt' onClick={handelrecipet}>
                <FontAwesomeIcon icon={faFilePdf} className="ml-2 text-danger" />
            </button>
            <button className='btn btn-sm action-btn' title='View Product' onClick={() => setShowViewModal(true)}>
                <FontAwesomeIcon icon={faEye} className="ml-2" />
            </button>

            <button className='btn btn-sm action-btn' title='Redirect To Sales Entry' onClick={handleCustomOrderToSalesEntery}>
                <FontAwesomeIcon icon={faPlus} className="ml-2 text-danger" />
            </button>

            <Modal size='xl' show={showViewModal} onHide={() => setShowViewModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Customer Order List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ShowCustomerOrderListModal selectedId={selectedId as number} handleClose={handleClose} reloadDataSource={reloadDataSource} />
                </Modal.Body>
            </Modal>


            <Modal size='lg' show={showVoucherModal} onHide={() => setShowVoucherModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Receipt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfData ? (
                        <iframe
                            src={`data:application/pdf;base64,${pdfData}`}
                            title="Voucher PDF"
                            width="100%"
                            height="500px"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <p>No PDF available.</p>
                    )}
                </Modal.Body>
            </Modal>





        </>
    )
}

export default ActionModal